import store from '@/store'

export default {
  inserted(el, binding, vnode) {
    const { value } = binding
    const buttons = store.getters && store.getters.button

    if (value && value instanceof Array && value.length > 0) {
      const conditionFlag = value

      const hasPermissions = buttons.some(btn => {
        return conditionFlag.includes(btn.name)
      })

      if (!hasPermissions) {
        el.parentNode && el.parentNode.removeChild(el)
      }
    } else {
      throw new Error(`请设置操作权限标签值`)
    }
  }
}



// WEBPACK FOOTER //
// ./src/directive/permission/hasBtn.js